import React from "react";
import ResourcePage from "../components/ResourcePage";

const VENDOR_CATEGORIES = ["Feed", "Medication", "Equipment", "Seeds", "Fertilizer", "Services", "Utilities", "Supplies", "Other"];

export function Vendors() {
  return (
    <ResourcePage
      title="Vendors"
      subtitle="Suppliers you buy feed, medication, equipment and services from — the source of truth for vendor details."
      endpoint="vendors"
      testid="ven"
      columns={[
        { key: "name", label: "Vendor", bold: true },
        { key: "category", label: "Category" },
        { key: "contact_person", label: "Contact" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "address", label: "Address" },
      ]}
      fields={[
        { key: "name", label: "Vendor name", type: "text" },
        { key: "category", label: "Category", type: "select", default: "Supplies",
          options: VENDOR_CATEGORIES.map((c) => ({ value: c, label: c })) },
        { key: "contact_person", label: "Contact person", type: "text" },
        { key: "phone", label: "Phone", type: "text" },
        { key: "email", label: "Email", type: "text" },
        { key: "address", label: "Address", type: "textarea", full: true },
        { key: "notes", label: "Notes", type: "textarea", full: true },
      ]}
    />
  );
}

export function Bills() {
  return (
    <ResourcePage
      title="Bills"
      subtitle="Vendor bills and expenses owed. Pick a vendor to auto-fill its name and category."
      endpoint="bills"
      testid="bill"
      columns={[
        { key: "bill_number", label: "Bill #", bold: true },
        { key: "vendor_name", label: "Vendor" },
        { key: "category", label: "Category" },
        { key: "date", label: "Date", type: "date" },
        { key: "amount", label: "Amount", type: "money" },
        { key: "status", label: "Status", type: "badge" },
        { key: "receipt_file", label: "Receipt", type: "file" },
      ]}
      fields={[
        { key: "bill_number", label: "Bill number", type: "text" },
        { key: "vendor_name", label: "Vendor", type: "relation", endpoint: "vendors",
          optionLabel: "name", idField: "vendor_id", fill: { category: "category" },
          allowCustom: true, full: true, placeholder: "Select a vendor" },
        { key: "category", label: "Category (auto-fills from vendor)", type: "text", default: "Supplies" },
        { key: "date", label: "Bill date", type: "date" },
        { key: "due_date", label: "Due date", type: "date" },
        { key: "amount", label: "Amount (₦)", type: "number" },
        { key: "status", label: "Status", type: "select", options: [
          { value: "unpaid", label: "Unpaid" }, { value: "paid", label: "Paid" }, { value: "overdue", label: "Overdue" }] },
        { key: "receipt_file", label: "Receipt / attachment (image or PDF)", type: "file", full: true },
        { key: "notes", label: "Notes", type: "textarea", full: true },
      ]}
    />
  );
}
